
// src/ReportSubscriptionPage/PricingSection.js
//import React from "react";
import { useAuth } from "./auth/useAuth";

import {
  FaBrain,
  FaComments,
  FaTasks,
  FaCheck,
  FaDownload,
  FaListAlt,
  FaChartBar,
  FaIdBadge,
  FaClipboardCheck,
  FaStar,
  FaCrown,
  FaCommentDots,
  FaChartPie,
  FaFileAlt,
} from "react-icons/fa";

// Backend base URL (from frontend .env)
const BACKEND_BASE_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

// 👉 Plan amounts in **RUPEES**
const PLAN_AMOUNTS = {
  Pro: 1, // Razorpay will show ₹199
  Premium: 2, // Razorpay will show ₹299
};

// Load Razorpay script
const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export default function FundUtilizerForm() {
  const { user } = useAuth();

  
  // Map feature text -> icon
  const getFeatureIcon = (text) => {
    const t = text.toLowerCase();

    // Premium-specific custom icons
    if (t.includes("exclusive feedback"))
      return <FaCommentDots className="subscription-icon" />;

    if (
      t.includes("section score") ||
      t.includes("their grades") ||
      t.includes("key observations")
    )
      return <FaChartPie className="subscription-icon" />;

    if (t.includes("executive summary"))
      return <FaFileAlt className="subscription-icon" />;

    // Generic / shared rules
    if (t.includes("score")) return <FaChartBar className="subscription-icon" />;
    if (t.includes("summary")) return <FaListAlt className="subscription-icon" />;
    if (t.includes("feedback"))
      return <FaComments className="subscription-icon" />;
    if (t.includes("customized") || t.includes("plans"))
      return <FaTasks className="subscription-icon" />;
    if (t.includes("remarks") || t.includes("actions"))
      return <FaClipboardCheck className="subscription-icon" />;
    if (t.includes("lacking") || t.includes("splitting"))
      return <FaBrain className="subscription-icon" />;
    if (t.includes("grades") || t.includes("observations"))
      return <FaStar className="subscription-icon" />;
    if (t.includes("user id") || t.includes("id"))
      return <FaIdBadge className="subscription-icon" />;
    if (t.includes("download"))
      return <FaDownload className="subscription-icon" />;

    return <FaCheck className="subscription-icon" />;
  };

  // Crown colors
  const getCrownColor = (title) => {
    if (title === "Pro") return "#c0c0c0"; // Silver
    if (title === "Premium") return "#ffd700"; // Gold
    return "#000";
  };

  // Common Razorpay flow for a plan
  const startReportPayment = async (plan) => {
    try {
      const loaded = await loadRazorpayScript();
      if (!loaded) {
        alert("Failed to load Razorpay SDK. Please check your internet connection.");
        return;
      }

      // 👉 Amount in RUPEES (your business logic)
      const rupeeAmount = PLAN_AMOUNTS[plan];
      if (!rupeeAmount) {
        alert("Invalid plan amount configuration.");
        return;
      }

      // Razorpay expects paise
      const amountInPaise = rupeeAmount * 100;

      // Optional: user info from localStorage / auth
      const name =  (user && user.name) || "Guest User";
      const email = (user && user.email) || "void@example.com";
      const contact =  (user && user.contact) || "9999999999";

      // 1) Create order in backend
      const createRes = await fetch(
        `${BACKEND_BASE_URL}/reportpayment/create-order`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            amount: amountInPaise, // 👈 paise to backend / Razorpay
            plan,
            currency: "INR",
            customer: {
              name,
              email,
              contact,
            },
          }),
        }
      );

      const createData = await createRes.json();
      console.log("Create order resp:", createRes.status, createData);

      if (!createRes.ok || !createData.success) {
        console.error("Create order response error:", createData);
        alert(createData.message || "Failed to create payment order.");
        return;
      }

      const { order_id, key_id, amount: orderAmount, currency } = createData;

      // 2) Open Razorpay checkout
      const options = {
        key: key_id,
        amount: orderAmount, // still paise: e.g. 19900
        currency,
        name: "MARSMATE AI",
        description: `${plan} Validation Report`,
        order_id,
        prefill: {
          name,
          email,
          contact,
        },
        theme: {
          color: plan === "Premium" ? "#ffd700" : "#c0c0c0",
        },
        handler: async function (response) {
          // Called when payment is SUCCESSFUL on Razorpay
          try {
            console.log("Razorpay handler response:", response);

            const verifyRes = await fetch(
              `${BACKEND_BASE_URL}/reportpayment/verify`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature,
                  plan,
                  customer_name: name,
                  customer_email: email,
                  customer_contact: contact,
                }),
              }
            );

            const verifyData = await verifyRes.json();
            console.log("Verify payment resp:", verifyRes.status, verifyData);
            console.log(verifyData,"verifydata")
            console.log(verifyRes,"res")

            if (!verifyRes.ok || !verifyData.success) {
              console.error("Verify payment failed:", verifyData);
              alert(
                verifyData.message ||
                  `Payment verification failed (status ${verifyRes.status}).`
              );
              return;
            }

            // ✅ At this point:
            // - Razorpay shows e.g. 199
            // - Backend (verifyReportPayment) stores 199 in rupees
            if (plan === "Premium") {
              localStorage.setItem("reportBAccess", true);
              window.location.href =
                "/reports";
              return;
            }

            localStorage.setItem("reportAccess", true);
            window.location.href =
              "/reports";
          } catch (err) {
            console.error("Error while verifying report payment:", err);
            alert("Something went wrong while verifying payment.");
          }
        },
        modal: {
          ondismiss: function () {
            console.log("Razorpay popup closed by user.");
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("Error in startReportPayment:", err);
      alert("Unable to start payment. Please try again.");
    }
  };


  const handleProClick = () => {
    startReportPayment("Pro")
  };

  const handlePremiumClick = () => {
    startReportPayment("Premium")
  };

  const plans = [
    {
      title: "Pro",
      price: "1", // display in UI
      subtitle: "Full Report Card",
      features: [
        "Your Score",
        "Your Validation Report",
        "Customized Plans",
        "Remarks & Recommended Actions",
        "Splitting and showing where you are lacking",
        "Download Feature",
      ],
      buttonText: "Get Pro",
      onClick: handleProClick,
    },
    {
      title: "Premium",
      price: "2",
      subtitle: "Advanced Report Card",
      features: [
        "Your Score",
        "Exclusive Feedback Based on Score",
        "Specific Section Score and Their Grades with Key Observations",
        "Special Executive Summary Based on Score",
        "Customized Plans",
        "Downloadable Option",
      ],
      buttonText: "Get Premium",
      onClick: handlePremiumClick,
    },
  ];

  return (
    <div className="subscription-wrapper">
      <h2 className="subscription-heading">Upgrade your plan</h2>

      <div className="subscription-cards">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`subscription-card ${plan.title.toLowerCase()}`}
          >
            {/* Title + crown */}
            <div className="subscription-title-row">
              <h3 className="subscription-title">{plan.title}</h3>
              <FaCrown
                className="subscription-crown"
                style={{ color: getCrownColor(plan.title) }}
              />
            </div>

            <div className="subscription-price-box">
              <span className="subscription-price">₹{plan.price}</span>
            </div>

            <p className="subscription-subtitle">{plan.subtitle}</p>

            <button className="subscription-btn" onClick={plan.onClick}>
              {plan.buttonText}
            </button>

            <ul className="subscription-features">
              {plan.features.map((f, i) => (
                <li key={i} className="subscription-feature-item">
                  {getFeatureIcon(f)}
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

